import { useSearchParams } from "react-router-dom";

const useQueryParams = () => useSearchParams()[0];
export default useQueryParams;
